import { render, staticRenderFns } from "./CompanyInformationForm.vue?vue&type=template&id=d0ba8d8e&"
import script from "./CompanyInformationForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./CompanyInformationForm.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports